import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { format } from "date-fns";
import moment from "moment";

import * as actions from "../../../../../store/actions";
import { parseDateToLocal } from "../../../../../utils/parseDateTime";
import "./index.css";

import StartCallIcon from "../../../../../components/uiElements/icons/profileIcons/StartCallIcon";
import LoadingSpinner from "../../../../../components/uiElements/loadingSpinner/LoadingSpinner";

const ShowVitals = ({ ongoingAppointment, getPatientVitals, apiUtil }) => {
  const [refresh, setRefresh] = useState(false);

  const vitals = ongoingAppointment?.vitals;

  useEffect(() => {
    getPatientVitals();
  }, [refresh, getPatientVitals]);

  return (
    <div className="calladdnotes px-2">
      <p>
        <span>Last updated {moment(vitals?.updated_at).fromNow(true)} ago</span>
        <span className="vital-refresh" onClick={() => setRefresh(!refresh)}>
          <StartCallIcon type="refresh" initial /> Refresh
        </span>
      </p>

      <div className="vital-card py-2 px-3 mb-3">
        <p className="vital-topic">
          <span>Blood Pressure</span>
          <span className="vital-date">
            {" "}
            {format(parseDateToLocal(vitals?.updated_at), "dd MMM")}
          </span>
        </p>
        <p className="vital-rate">{vitals?.blood_pressure || " - "}</p>
      </div>

      <div className="vital-card py-2 px-3 mb-3">
        <p className="vital-topic">
          <span>Pulse</span>
          <span className="vital-date">
            {format(parseDateToLocal(vitals?.updated_at), "dd MMM")}
          </span>
        </p>
        <p className="vital-rate">{vitals?.pulse || " - "}</p>
      </div>

      <div className="vital-card py-2 px-3 mb-3">
        <p className="vital-topic">
          <span>Oxygen Saturation</span>
          <span className="vital-date">
            {format(parseDateToLocal(vitals?.updated_at), "dd MMM")}
          </span>
        </p>
        <p className="vital-rate">{vitals?.oxygen_saturation || " - "}</p>
      </div>
      <div className="vital-card py-2 px-3 mb-3">
        <p className="vital-topic">
          <span>Weight</span>
          <span className="vital-date">
            {format(parseDateToLocal(vitals?.updated_at), "dd MMM")}
          </span>
        </p>
        <p className="vital-rate">{vitals?.weight || " - "}</p>
      </div>
      <div className="vital-card py-2 px-3 mb-3">
        <p className="vital-topic">
          <span>Height</span>
          <span className="vital-date">
            {format(parseDateToLocal(vitals?.updated_at), "dd MMM")}
          </span>
        </p>
        <p className="vital-rate">{vitals?.height || " - "}</p>
      </div>
      {apiUtil.isLoading && (
        <div className="center-content">
          <LoadingSpinner asOverlay={true} />
        </div>
      )}
    </div>
  );
};

const mapStoreToProps = ({ dashboard, api }) => ({
  ongoingAppointment: dashboard.ongoingAppointment,
  apiUtil: api,
});

const mapDispatchToProps = dispatch => ({
  getPatientVitals: () => dispatch(actions.getPatientVitals()),
});

export default connect(mapStoreToProps, mapDispatchToProps)(ShowVitals);
